<ng-template #periodSettingsContent>
  <div class="global-settings-container">
    <div class="tab-title">
      <span class="container-left-padding">Period Settings</span>
    </div>
    <div class="divider"></div>
    <div class="sub-header">
      <div class="option-title normal-style">
        <span class="">Select Period Calculation Methods</span>
      </div>
      <div>
        <span class="note container-left-padding">Applies to: </span>
        <span class="global-user-setting-modal-subheader-note-text">
          Valuation, Peer Analysis, Charts Page, Industry Analysis, Target Price
          & Ratings and Excel Addin.</span
        >
      </div>
    </div>
    <div class="padding-top-20">
      <div class="option-title with-bg">
        <span class="">Calendarization Method</span>
        <span
          nz-popover
          [nzPopoverTitle]="calendarizationTitle"
          nzPopoverPlacement="left"
          [nzPopoverContent]="calendarizationMethodsTooltip"
          nzOverlayClassName="global-setting-modal-info-modal"
          class="learn-more"
        >
          <va-icon size="small" name="info-circle"></va-icon>
          Learn More
        </span>
      </div>
      <div>
        <div nz-row nzType="flex" [nzGutter]="8" class="cal-method-div">
          <div nz-col>
            <span>Default Method - </span>
          </div>
          <div nz-col>
            <div>Annual Interpolation</div>
            <label
              class="color-black mt-12"
              nz-checkbox
              [(ngModel)]="hasAdjustedInterims"
              >Use Adjusted Interims when available</label
            >
          </div>
        </div>
      </div>
    </div>
    <div class="padding-top-32">
      <div class="option-title with-bg">
        <span class="container-left-padding"
          >LTM / NTM / STM Calculation Method</span
        >
        <span
          nz-popover
          [nzPopoverTitle]="ltmntmstmTitle"
          nzPopoverPlacement="left"
          [nzPopoverContent]="ltmntmstmMethodsTooltip"
          class="learn-more"
          nzOverlayClassName="global-setting-modal-info-modal"
        >
          <va-icon size="small" name="info-circle"></va-icon>
          Learn More
        </span>
      </div>
      <div class="period-radio-box">
        <nz-radio-group [(ngModel)]="ltmntlstmCalculationMethod">
          <div *ngFor="let item of ntmStmOptions" class="val-pcp-radio-wrapper">
            <label nz-radio [nzValue]="item.id" class="val-pcp-radio-label">{{
              item.label
            }}</label>
            <span
              class="gsm-period-radio-note"
              *ngIf="hasAdjustedInterims && item.id === 'NotUnreported'"
              >(using Adjusted Interims)</span
            >
            <span
              class="gsm-period-radio-note"
              *ngIf="!hasAdjustedInterims && item.id === 'NotUnreported'"
              >(using Annual Interpolation)</span
            >
          </div>
        </nz-radio-group>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #calendarizationMethodsTooltip>
  <div>
    <p style="color: #070809; line-height: 24px">
      <span style="font-weight: bold"> Annual Interpolation </span>
      uses a quarterly, time-weighted interpolation of <br />
      the annual fiscal numbers.
    </p>
  </div>
  <div>
    <p style="color: #070809; line-height: 24px">
      <span style="font-weight: bold"> Adjusted Interims </span>
      uses the sum (or other calculation) of the quarterly or <br />
      semi-annual values falling within a calendar year, adjusted for annual
      only <br />
      forecasters
    </p>
  </div>
  <div style="height: 181px">
    <img [src]="calendarization_method_image" />
  </div>
  <div style="padding-top: 24px">
    <a
      [href]="calendarization_methods"
      target="_blank"
      style="font-style: italic"
    >
      <u>See more examples and availability details on our Support Site</u>
    </a>
  </div>
</ng-template>

<ng-template #ltmntmstmMethodsTooltip>
  <div>
    <p style="color: #070809">
      <span style="font-weight: bold"> Rolling 365 Days </span>
      calculates a daily interpolation of fiscal periods covering the next
      <br />
      365 days, reported or not, starting tomorrow.
    </p>
  </div>
  <div>
    <p style="color: #070809">
      <span style="font-weight: bold"> Unreported Periods </span>
      uses the sum of the next four unreported quarters (or the <br />
      next two semi-annual periods)
    </p>
  </div>
  <div style="height: 245px">
    <img [src]="ltm_ntm_stm_calculation_method_image" />
  </div>
  <div style="padding-top: 24px">
    <a
      [href]="rolling_periods_calculation_methods"
      target="_blank"
      style="font-style: italic"
    >
      <u>See more examples and availability details on our Support Site</u>
    </a>
  </div>
</ng-template>

<ng-template #calendarizationTitle>
  <div style="font-weight: bold; color: black; font-size: 16px">
    Calendarization Methods
  </div>
</ng-template>

<ng-template #ltmntmstmTitle>
  <div style="font-weight: bold; color: black; font-size: 16px">
    LTM / NTM / STM Calculation Methods
  </div>
</ng-template>

<ng-template #excelSettingContent>
  <div class="global-settings-container excel-global-settings-container">
    <div class="tab-title">Excel Settings</div>
    <div class="divider"></div>
    <div id="addinUserSettingsModalContent">
      <div class="option-title">Ticker Type</div>
      <nz-radio-group [nzSize]="'small'" [(ngModel)]="tickerType">
        <label nz-radio class="radio-btn" nzValue="VA">VA Tickers</label>
        <label nz-radio class="radio-btn" nzValue="B">Bloomberg</label>
      </nz-radio-group>
      <div class="option-title">Currency Compatible</div>
      <nz-radio-group [nzSize]="'small'" [(ngModel)]="currencyCompatible">
        <label nz-radio class="radio-btn" nzValue="true">Yes</label>
        <label nz-radio class="radio-btn" nzValue="false">No</label>
      </nz-radio-group>
    </div>
  </div>
</ng-template>
<ng-template #excelSettingContentAdvanced>
  <div class="global-settings-container excel-global-settings-container">
    <div class="tab-title">Excel Settings</div>
    <div class="divider"></div>
    <div id="addinUserSettingsModalContent">
      <div class="option-title">Ticker Type</div>
      <nz-radio-group [nzSize]="'small'" [(ngModel)]="tickerType">
        <label nz-radio class="radio-btn" nzValue="VA">VA Tickers</label>
        <label nz-radio class="radio-btn" nzValue="B">Bloomberg</label>
      </nz-radio-group>
    </div>
    <div class="divider"></div>
    <div class="option-title">Advanced Options</div>
    <label nz-checkbox class="radio-btn" [(ngModel)]="isRTDDisabled"
      >RTD servers</label
    >
    <label nz-checkbox class="radio-btn" [(ngModel)]="percentAbsValue"
      >Show numbers shown in % (such as margins) on an absolute basis</label
    >
    <span>Convert null values to </span>
    <nz-radio-group [nzSize]="'small'" [(ngModel)]="blankValue">
      <label nz-radio class="radio-btn" nzValue="AsZero">0.000</label>
      <label nz-radio class="radio-btn" nzValue="AsHyphen">-</label>
    </nz-radio-group>
  </div>
</ng-template>
<!-- <app-export-to-excel
    #eteModal
    [isModalOpen]="isVisibleEteModal"
    gsModal=true
    (onClose)="onCloseEteModal()"
  >
  </app-export-to-excel> -->

<ng-template #modalBtn>
  <div class="btn-container">
    <button
      nz-button
      nzType="primary"
      style="background: #36abad"
      (click)="onApplyClick()"
    >
      Apply
    </button>
  </div>
</ng-template>

<ng-template #periodSettingCustomIcon>
  <svg
    class="global-user-setting-tab-period-setting-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.14139 1.02627V2.05254H9.25451V1.02627C9.25451 0.459577 9.71402 0 10.2828 0C10.8516 0 11.3111 0.459577 11.3111 1.02627V2.05254H12.8535C13.705 2.05254 14.3959 2.74175 14.3959 3.59195V5.13135H0V3.59195C0 2.74175 0.690553 2.05254 1.54242 2.05254H3.08484V1.02627C3.08484 0.459577 3.54435 0 4.11311 0C4.68188 0 5.14139 0.459577 5.14139 1.02627ZM0 6.15762H14.3959V7.1628C14.2121 7.14075 14.025 7.12941 13.8353 7.12941C11.2623 7.12941 9.17647 9.21524 9.17647 11.7882C9.17647 14.1232 10.8942 16.0569 13.1348 16.3947C13.0436 16.4115 12.9496 16.4203 12.8535 16.4203H1.54242C0.690553 16.4203 0 15.7308 0 14.8809V6.15762ZM2.05656 9.74957C2.05656 10.0318 2.28663 10.2627 2.5707 10.2627H3.59898C3.88175 10.2627 4.11311 10.0318 4.11311 9.74957V8.7233C4.11311 8.44107 3.88175 8.21016 3.59898 8.21016H2.5707C2.28663 8.21016 2.05656 8.44107 2.05656 8.7233V9.74957ZM6.16967 9.74957C6.16967 10.0318 6.40103 10.2627 6.68381 10.2627H7.71209C7.99487 10.2627 8.22623 10.0318 8.22623 9.74957V8.7233C8.22623 8.44107 7.99487 8.21016 7.71209 8.21016H6.68381C6.40103 8.21016 6.16967 8.44107 6.16967 8.7233V9.74957ZM2.05656 13.8546C2.05656 14.1369 2.28663 14.3678 2.5707 14.3678H3.59898C3.88175 14.3678 4.11311 14.1369 4.11311 13.8546V12.8284C4.11311 12.5462 3.88175 12.3152 3.59898 12.3152H2.5707C2.28663 12.3152 2.05656 12.5462 2.05656 12.8284V13.8546ZM6.68381 12.3152C6.40103 12.3152 6.16967 12.5462 6.16967 12.8284V13.8546C6.16967 14.1369 6.40103 14.3678 6.68381 14.3678H7.71209C7.99487 14.3678 8.22623 14.1369 8.22623 13.8546V12.8284C8.22623 12.5462 7.99487 12.3152 7.71209 12.3152H6.68381ZM17.1679 12.3961L17.8962 12.7988C17.98 12.8446 18.0176 12.9395 17.992 13.0295C17.8022 13.6138 17.4791 14.1408 17.0568 14.5778C16.9918 14.6465 16.8875 14.6612 16.8038 14.6154L16.0755 14.2128C15.7677 14.4632 15.4156 14.6579 15.036 14.7872V15.5925C15.036 15.6841 14.9693 15.7643 14.8753 15.7839C14.2787 15.9116 13.6358 15.9181 13.0084 15.7839C12.9144 15.7643 12.8477 15.6841 12.8477 15.5925V14.7872C12.4665 14.6596 12.1143 14.4648 11.8082 14.2128L11.0799 14.6154C10.9979 14.6612 10.8919 14.6449 10.8269 14.5778C10.4046 14.1391 10.0815 13.6122 9.89176 13.0295C9.86441 12.9411 9.90202 12.8462 9.98579 12.8004L10.7141 12.3978C10.6406 12.0181 10.6406 11.6286 10.7141 11.2489L9.98579 10.8463C9.90202 10.8004 9.8627 10.7055 9.89176 10.6171C10.0815 10.0329 10.4046 9.50588 10.8269 9.06891C10.8919 9.00017 10.9962 8.98544 11.0799 9.03126L11.8065 9.43387C12.1143 9.18347 12.4665 8.98871 12.846 8.85942V8.0542C12.846 7.96255 12.9127 7.88236 13.0067 7.86272C13.6034 7.73506 14.2462 7.72852 14.8736 7.86272C14.9676 7.88236 15.0343 7.96255 15.0343 8.0542V8.85778C15.4156 8.98544 15.7677 9.1802 16.0738 9.43223L16.8021 9.02963C16.8841 8.9838 16.9901 9.00017 17.0551 9.06727C17.4774 9.50588 17.8005 10.0329 17.9902 10.6155C18.0176 10.7039 17.98 10.7988 17.8962 10.8446L17.1679 11.2472C17.2414 11.6269 17.2414 12.0165 17.1679 12.3961ZM12.5724 11.8217C12.5724 12.5434 13.1862 13.131 13.9401 13.131C14.6941 13.131 15.3078 12.5434 15.3078 11.8217C15.3078 11.0999 14.6941 10.5124 13.9401 10.5124C13.1862 10.5124 12.5724 11.0999 12.5724 11.8217Z"
      fill="currentColor"
    />
  </svg>
</ng-template>

<app-left-tab-modal-design
  [tabDetails]="tabs"
  [title]="gblSettingModalTitle"
  [selectedTabIndex]="selectedTabIndex"
  [(isModalOpen)]="isVisibleEteModal"
  [periodSettingsContent]="periodSettingsContent"
  [btnTemplate]="modalBtn"
  [showClose]="showClose"
  (onClose)="onCloseEteModal()"
>
</app-left-tab-modal-design>
